<template>
  <div
    :class="['-item', { '-selected': selected }]"
    :data-anim-id="anim.id"
    @mouseenter="$_toggleHover"
    @mouseleave="$_toggleHover"
    @click="$emit('click', anim)"
  >
    <div class="-screen">
      <img v-if="showDefaultImage" :src="srcFallbackImage" alt="" />

      <animation-item-player
        v-if="showPlayer"
        :isHovered="isHovered"
        :src="mixinSrc(anim.icon)"
        :title="showTitles && anim.displayText"
        @error="$_recoverableError('player')"
      />

      <img
        v-if="showImage"
        alt=""
        :src="mixinSrc(anim.icon)"
        :title="showTitles && anim.displayText"
        @error="$_recoverableError('image')"
      />

      <img
        v-if="showNone"
        src="/resources/img/toAnimations/no-animation-v3.png"
        alt=""
      />
    </div>

    <div class="-label" v-text="anim.displayText" />
  </div>
</template>

<script>
import app from 'app';
import AnimationItemPlayer from './AnimationItemPlayer.vue';

export default {
  components: {
    AnimationItemPlayer,
  },

  props: {
    anim: { type: Object, required: true },
    selected: { type: Boolean, required: true },
    showTitles: { type: Boolean, required: false, default: true },
    autoscroll: { type: Boolean, required: false, default: true },
  },

  data() {
    return {
      playerError: false,
      imageError: false,
      isHovered: false,
      showDefaultImage: false,
    };
  },

  computed: {
    showPlayer() {
      return !this.playerError && /\.gif\b/i.test(this.anim.icon);
    },

    showImage() {
      return !this.imageError && /\.png\b/i.test(this.anim.icon);
    },

    showNone() {
      return this.anim.displayText === 'None';
    },

    srcFallbackImage() {
      return app.ANIMATION.FALLBACK.icon;
    },
  },

  watch: {
    anim: {
      deep: true,
      handler() {
        this.playerError = false;
        this.imageError = false;
        this.showDefaultImage = false;
      },
    },
  },

  mounted() {
    if (this.autoscroll && this.selected) {
      this.$nextTick(() => {
        if (!this._isDestroyed) {
          this.$el?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      });
    }
  },

  methods: {
    $_toggleHover(e) {
      this.isHovered = e.type === 'mouseenter';
    },

    $_recoverableError(resource) {
      if ('player' === resource) {
        this.playerError = true;
      } else {
        this.imageError = true;
      }
      this.showDefaultImage = true;
    },
  },
};
</script>

<style lang="scss">
.-item {
  img,
  canvas {
    width: 100%;
    height: 100%;
  }
}
</style>
